"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabel = void 0;
const getLabel = (context) => {
    let label = context.dataset.label || '';
    let data;
    switch (context.chart.config._config.type) {
        case 'bar':
            if (context.chart.config._config.options.indexAxis === 'y')
                data = context.parsed.x || '';
            else
                data = context.parsed.y || '';
            break;
        case 'line':
            data = context.parsed.y || '';
            break;
        default:
            data = context.parsed || '';
    }
    if (data)
        label = label ? `${label}: ${data}` : data;
    return ` ${label}`;
};
exports.getLabel = getLabel;
